import UserTable from "./UserTable";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";





function UserTableView() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <UserTable/>
            </BasicCard>
        </>
    )
}
export default UserTableView;